.loading {
	display: flex;
	justify-content: center;
}

.error {
	color: var(--color-error-text);

	&:empty {
		display: none;
	}
}
